var _style, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutorials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 150",
    style: {
      enableBackground: "new 0 0 200 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CFDDF9;}\n\t.st1{fill:#D4E8FF;}\n\t.st2{fill:#EEF7FF;}\n\t.st3{fill:#DCE6FF;}\n\t.st4{fill:#3A72AA;}\n\t.st5{fill:#255084;}\n\t.st6{fill:#1D3F70;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#B0C7F5;}\n\t.st9{fill:#BFD2F9;}\n\t.st10{fill:#EB5648;}\n\t.st11{fill:#677CC1;}\n\t.st12{fill:#4867AA;}\n\t.st13{fill:#395B96;}\n\t.st14{fill:#DCECFF;}\n\t.st15{fill:#98B6EA;}\n\t.st16{fill:#2F99F1;}\n\t.st17{fill:#245EA3;}\n\t.st18{fill:#F99370;}\n\t.st19{fill:#E8C0A6;}\n\t.st20{fill:#D1A68F;}\n\t.st21{fill:#E57D61;}\n\t.st22{fill:#8C4225;}\n\t.st23{fill:#C16256;}\n\t.st24{fill:#7689D6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,124.91c0,0-0.15,4.63,5.64,5.81c7.92,1.62,51.61,5.76,40.32,9c-6.38,1.83,4.97,4.22,36.03,5.13 c31.06,0.91,84.36-2.67,66.43-7.97c-17.92-5.3,50.79-0.85,50.85-11.98H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.17,124.53c0,0-22.52-63.62-5.63-77.16c11.28-9.05,22.3,13.73,36.58,3.18c12.71-9.39,4.49-31.47,16.95-41.92 c17.91-15.03,40.64,51.6,58.5,41.58c28.09-15.77,45.27,9.11,25.76,74.44L35.17,124.53z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.67,90.76c-7.99-1.48-7.27,20.78-18.66,20.78c-10.42,0-15.99-49.72-27.42-39.61 c-45.96,40.66-10.2-28.53-41.1-29.88C87.51,41.43,78.2,60.05,74.76,93.02c-4.98,29.81-16.52-22.74-28.4-17.85 c-7.55,3.1-6.68,36.36-17.1,36.36c-11.39,0-10.64-18.71-18.64-17.23C2.02,95.89,0,124.91,0,124.91h199.26 C199.26,124.91,197.27,92.35,188.67,90.76z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M181.01,115.95c-7.35-0.53-6.15,4.22-16.64,4.22c-9.58,0-9.32-10.63-15.73-12.89 c-11.81-4.16-21.55,16.9-26.13,6.33c-8.7-28.05-34.06-42.11-45.76,0c-4.58,10.57-15.29-8.29-26.13-6.33 c-6.67,1.21-6.15,12.89-15.73,12.89c-10.48,0-9.28-4.74-16.64-4.22c-7.92,0.57-10.28,8.96-10.28,8.96h183.32 C191.29,124.91,188.93,116.51,181.01,115.95z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "_x39_",
    className: "st4",
    d: "M29.81,10.03c-7.75,2.54-11.98,10.88-9.44,18.63c2.54,7.75,10.88,11.98,18.63,9.44 c7.75-2.54,11.98-10.88,9.44-18.63C45.91,11.71,37.56,7.49,29.81,10.03z M29.23,34.14c-1.8,0.59-3.73-0.39-4.32-2.19 c-0.59-1.8,0.39-3.73,2.19-4.32c1.8-0.59,3.73,0.39,4.32,2.19C32,31.62,31.02,33.55,29.23,34.14z M26.46,25.54 c-1.8,0.59-3.73-0.39-4.32-2.19c-0.59-1.8,0.39-3.73,2.19-4.32c1.8-0.59,3.73,0.39,4.32,2.19C29.24,23.02,28.26,24.95,26.46,25.54z  M38.33,35.94c-1.8,0.59-3.73-0.39-4.32-2.19c-0.59-1.8,0.39-3.73,2.19-4.32c1.8-0.59,3.73,0.39,4.32,2.19 C41.11,33.41,40.13,35.35,38.33,35.94z M32.68,18.68c-1.8,0.59-3.73-0.39-4.32-2.19c-0.59-1.8,0.39-3.73,2.19-4.32 c1.8-0.59,3.73,0.39,4.32,2.19C35.46,16.15,34.48,18.09,32.68,18.68z M39.56,14.14c1.8-0.59,3.73,0.39,4.32,2.19 c0.59,1.8-0.39,3.73-2.19,4.32c-1.8,0.59-3.73-0.39-4.32-2.19C36.78,16.67,37.76,14.73,39.56,14.14z M44.53,29.06 c-1.8,0.59-3.73-0.39-4.32-2.19c-0.59-1.8,0.39-3.73,2.19-4.32c1.8-0.59,3.73,0.39,4.32,2.19C47.31,26.54,46.33,28.47,44.53,29.06z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x37_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.79,
    y: 101.61,
    className: "st5",
    width: 23.56,
    height: 21.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.79,
    y: 89.09,
    className: "st6",
    width: 23.56,
    height: 24.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M135.66,127.13H63.47c-1.45,0-2.62-1.17-2.62-2.62l0,0c0-1.45,1.17-2.62,2.62-2.62h72.18 c1.45,0,2.62,1.17,2.62,2.62l0,0C138.28,125.95,137.11,127.13,135.66,127.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.23,70.65v-9.64c0-21.64,17.55-39.19,39.19-39.19h54.51c21.64,0,39.19,17.55,39.19,39.19v9.64 c0,21.64-17.55,39.19-39.19,39.19H72.42C50.77,109.84,33.23,92.29,33.23,70.65z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.32,
    y: 26.93,
    className: "st7",
    width: 122.48,
    height: 71.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 99.56,
    cy: 104.83,
    r: 2.78
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.18,
    y: 30.37,
    className: "st8",
    width: 70.72,
    height: 46.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.18,
    y: 76.75,
    className: "st5",
    width: 70.72,
    height: 5.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M108.8,80.11H89.47c-0.23,0-0.41-0.18-0.41-0.41c0-0.22,0.18-0.41,0.41-0.41h19.33c0.23,0,0.41,0.18,0.41,0.41 C109.21,79.92,109.02,80.11,108.8,80.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89.47,80.11H48.74c-0.23,0-0.41-0.18-0.41-0.41c0-0.22,0.18-0.41,0.41-0.41h40.73 c0.23,0,0.41,0.18,0.41,0.41C89.88,79.92,89.7,80.11,89.47,80.11z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st11",
    cx: 89.47,
    cy: 79.7,
    rx: 1.31,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M44.64,81.43c-0.23,0-0.41-0.18-0.41-0.41v-2.65c0-0.22,0.18-0.41,0.41-0.41c0.23,0,0.41,0.18,0.41,0.41v2.65 C45.05,81.25,44.86,81.43,44.64,81.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M46.12,81.43c-0.23,0-0.41-0.18-0.41-0.41v-2.65c0-0.22,0.18-0.41,0.41-0.41c0.23,0,0.41,0.18,0.41,0.41v2.65 C46.53,81.25,46.34,81.43,46.12,81.43z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 77.3,
    cy: 53.75,
    r: 10.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M77.3,65.19c-6.31,0-11.44-5.13-11.44-11.44c0-6.31,5.13-11.44,11.44-11.44c6.31,0,11.44,5.13,11.44,11.44 C88.74,60.06,83.61,65.19,77.3,65.19z M77.3,44.38c-5.17,0-9.37,4.2-9.37,9.37s4.2,9.37,9.37,9.37s9.37-4.2,9.37-9.37 S82.47,44.38,77.3,44.38z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "83.43,53.75 73.66,48.11 73.66,59.39  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.14,
    y: 84.78,
    className: "st8",
    width: 11.42,
    height: 11.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.97,
    y: 84.78,
    className: "st8",
    width: 11.42,
    height: 11.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.8,
    y: 84.78,
    className: "st8",
    width: 11.42,
    height: 11.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.63,
    y: 84.78,
    className: "st8",
    width: 11.42,
    height: 11.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.47,
    y: 84.78,
    className: "st8",
    width: 11.42,
    height: 11.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.3,
    y: 84.78,
    className: "st8",
    width: 11.42,
    height: 11.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.13,
    y: 84.78,
    className: "st8",
    width: 11.42,
    height: 11.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.96,
    y: 84.78,
    className: "st8",
    width: 11.42,
    height: 11.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 64.17,
    className: "st8",
    width: 41.05,
    height: 18.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 59.61,
    className: "st8",
    width: 41.05,
    height: 2.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 40.09,
    className: "st8",
    width: 41.05,
    height: 2.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 44.97,
    className: "st8",
    width: 41.05,
    height: 2.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 54.73,
    className: "st8",
    width: 41.05,
    height: 2.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 49.85,
    className: "st8",
    width: 41.05,
    height: 2.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 30.33,
    className: "st11",
    width: 7.13,
    height: 7.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.64,
    y: 30.33,
    className: "st8",
    width: 7.13,
    height: 7.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.95,
    y: 30.33,
    className: "st11",
    width: 7.13,
    height: 7.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.25,
    y: 30.33,
    className: "st8",
    width: 7.13,
    height: 7.13
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.89,
    y: 104.15,
    className: "st12",
    width: 53.52,
    height: 2.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "121.27,102.73 184.02,102.73 184.02,104.26 180.45,104.26 180.45,139.12 179.06,139.12  179.06,104.26 126.23,104.26 126.23,139.12 124.84,139.12 124.84,104.26 121.27,104.26  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.08,
    y: 97.68,
    className: "st5",
    width: 3.72,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.08,
    y: 95.2,
    className: "st6",
    width: 3.72,
    height: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M167.08,102.71h-14.3c-0.29,0-0.52-0.23-0.52-0.52l0,0c0-0.29,0.23-0.52,0.52-0.52h14.3 c0.29,0,0.52,0.23,0.52,0.52l0,0C167.6,102.48,167.37,102.71,167.08,102.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145.89,98.18l0.52-16.47c0-0.62,0.51-1.13,1.13-1.13h25.83c0.62,0,1.13,0.51,1.13,1.13l-0.52,16.47 c0,0.62-0.51,1.13-1.13,1.13h-25.83C146.4,99.31,145.89,98.8,145.89,98.18z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "173.4,81.68 172.88,96.9 146.99,96.9 147.51,81.68  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 159.94,
    cy: 98.12,
    r: 0.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "148.62,95.03 170.65,95.03 171.25,83.55 149.22,83.55  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 159.94,
    cy: 89.29,
    r: 3.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M159.94,93.57c-2.36,0-4.28-1.92-4.28-4.28c0-2.36,1.92-4.28,4.28-4.28c2.36,0,4.28,1.92,4.28,4.28 C164.21,91.65,162.3,93.57,159.94,93.57z M159.94,85.79c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5c1.93,0,3.5-1.57,3.5-3.5 S161.87,85.79,159.94,85.79z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "162.23,89.29 158.58,87.18 158.58,91.4  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M136.48,106.63l1.62-2.45c0,0-1.18-1.15-2.01-1.56c-0.91-0.45-0.95-1.52-0.48-2.63c0,0,0,0,0,0 c0.54-1.28,1.76-2.63,3.09-3.13c0.14-0.05,0.28-0.1,0.42-0.13c0.05-0.01,0.1-0.03,0.15-0.04c2.97-0.91,3.49-6.98,3.57-9.05v0 c0.02-0.43,0.02-0.68,0.02-0.68s-0.26,0.01-0.73,0.08c-1.42,0.23-4.73,1.06-8.16,4.06C129.43,95.1,126,104.99,136.48,106.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M135.61,100c0.6-1.42,2.03-2.91,3.51-3.27c0.05-0.01,0.1-0.03,0.15-0.04l-0.24-2.68 C139.03,94.01,136.33,97.51,135.61,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M142.87,85.11v1.85c0,0,1.31,1.29,3.16-0.13v-2.78L142.87,85.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M141.7,96.79c0,0,11.69,5.83,12.35,8.08c11.7,4.49,7.73,15.77-0.08,25.86c-1.19,2.21,2.73,2.87,2.91,4.69 c0.04,0.43-0.41,0.72-0.79,0.53l-6.59-3.45c1.64-2.32,6.95-13.64,3.44-18.72c-3.61-3.3-5.5-7.61-9.7-8.48 C139.89,104.55,138.77,100.59,141.7,96.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M149.62,131.77c-0.09,0.24-0.14,0.49-0.13,0.74l6.65,3.48c0.32,0.17,0.72-0.03,0.78-0.39 c0.12-0.85-0.22-2.34-3.2-4.1c0,0-1.29-0.31-2.84-1.51C150.88,129.98,149.99,130.81,149.62,131.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M156.92,135.58l-7.3-3.82c-0.09,0.24-0.14,0.49-0.13,0.74l6.65,3.48 C156.47,136.16,156.88,135.95,156.92,135.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M143.24,97.92c0,0,2.69,2.56,3.34,4.81c11.7,4.49,7.73,15.77-0.08,25.86c-1.19,2.21,2.73,2.87,2.91,4.69 c0.04,0.43-0.41,0.72-0.79,0.53l-6.59-3.45c1.64-2.32,6.95-13.64,3.44-18.72c-3.61-3.3-3.95-5.11-8.15-5.98 C137.32,105.67,140.31,101.72,143.24,97.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M137.57,103.32h15.33c0,0,5.79,1.67,7.88,6.2c0,0,0,0.01,0.01,0.01c0.9,1.71,1.52,4.07,1.18,7.23 c-0.68,6.31-3.76,10.64-5.22,12.37c0,0,0,0,0,0c-0.47,0.55-0.77,0.84-0.77,0.84s-3.39,0.21-5.82-2.14c0,0,0.19-0.4,0.47-1.08 c0.94-2.23,2.95-7.51,3.06-11.84c-0.2,2-1.21,5.79-5.1,12.09h0c-0.07,0.1-0.14,0.2-0.21,0.31c-0.12,0.17-0.24,0.35-0.37,0.53 c0,0-3.48-0.44-5.75-2.74c0,0,0.22-0.41,0.56-1.1c1.02-2.05,3.1-6.62,3.61-10.58l-8.44-0.42 C134.13,109.29,137.57,103.32,137.57,103.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M142.26,125.1c2.27,2.3,5.75,2.74,5.75,2.74c0.2-0.28,0.4-0.56,0.58-0.83c0,0-4.63-1.28-5.77-3v0 C142.48,124.7,142.26,125.1,142.26,125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M142.16,129.63c-0.09,0.24-0.14,0.49-0.13,0.74l6.65,3.48c0.32,0.17,0.72-0.03,0.78-0.39 c0.12-0.85-0.22-2.34-3.2-4.1c0,0-1.29-0.31-2.84-1.51C143.42,127.84,142.52,128.67,142.16,129.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M149.46,133.44l-7.3-3.82c-0.09,0.24-0.14,0.49-0.13,0.74l6.65,3.48 C149.01,134.02,149.42,133.81,149.46,133.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M150.63,126.76c-0.29,0.68-0.47,1.08-0.47,1.08c2.43,2.35,5.82,2.14,5.82,2.14s0.3-0.29,0.77-0.84 C156.67,129.13,152.31,128.58,150.63,126.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M147.1,126.95l1.28,0.37c0.07-0.1,0.14-0.21,0.21-0.31h0c6.38-10.33,5.02-13.91,5.02-13.91l-1.14-0.17 C152.47,112.93,152.68,119.57,147.1,126.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M137.57,103.32c0,0,5.68,3.76,15.33,0c0-0.16,0-0.34-0.01-0.52c-0.01-0.35-0.02-0.73-0.04-1.15 c-0.1-1.86-0.34-4.3-0.74-6.28c-0.12-0.6-0.26-1.16-0.41-1.65c-0.71-3.08-3.01-5.62-5.1-6.64c-0.19-0.09-0.38-0.18-0.57-0.24 c0,0-0.85,0.58-1.64,0.58c-1-0.01-1.53-0.45-1.53-0.45c-0.18,0.08-0.36,0.18-0.54,0.28c-1.99,1.25-3.36,4.44-3.63,9.62 c-0.01,0.26-0.02,0.53-0.03,0.8C138.49,100.11,138.35,101.24,137.57,103.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M145.79,91.81c3.65,3.1,6.16,10.63,11.81,10.29c3.46-0.68,5.39-3.98,6.99-6.75c0.25-0.48,0.49-0.96,0.71-1.46 c0.51-1.08-1.05-2.03-1.78-1.1c-1.64,1.76-4.05,5.15-6.38,5.38c-1.37-0.63-2.16-2.23-3.01-3.47c-1.47-2.33-2.83-4.66-4.9-6.59 C146.76,85.89,143.4,89.51,145.79,91.81L145.79,91.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M155.3,111.79c0,0-2.83,0.33-4.59,0.22l2.51,0.92C153.21,112.93,154.03,112.49,155.3,111.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M164.09,89.96c0.4,0.07,0.07,0.98,0.22,1.32c0.49-0.44,0.85-1.02,0.85-1.02c0.3-0.75,0.55-1.52,0.78-2.3 c0.89-0.85-0.02,2.11-0.05,2.42c0,0,0.01,0,0.01,0.01c0.47-0.71,0.9-1.44,1.27-2.2c1.11-0.67-0.6,2.33-0.73,2.62c0,0,0,0,0,0 c0.55-0.59,1.04-1.25,1.44-1.94c1.17-0.58-0.79,2.34-1.01,2.58c0,0,0,0.01,0,0.01c0.5-0.4,0.95-0.86,1.38-1.34 c1.17-0.38-0.89,1.9-1.12,2.1c-0.09,0.21-0.92,1.06-2.13,1.85c-0.4,0.26-1.37-0.64-1.4-1.11c-0.03-0.44,0.1-1.02,0.14-1.23 C163.75,91.3,163.62,90.09,164.09,89.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M146.56,94.77c0,0,1.47,5.11,6.23,7.94c0.04,0.02,0.08,0.05,0.11,0.08c-0.04-1.89-0.3-5-0.79-7.43 L146.56,94.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M142.93,85.15c2.43,0.97,4.52,0.67,5.74-0.58c1.97-2.01,0.07-4.37,0-6.5c-0.05-0.57-0.02-0.99-0.02-0.99 C140.43,78.01,142.5,85.12,142.93,85.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M144.55,84.83c0.43-0.05,2.1-0.32,2.24-1.19c0.14-0.88,0.32-1.23,0.32-1.23l0.86-1.46 c-0.21-1.35,0.66-2.81,0.69-2.86c0,0,0,0,0,0c-0.05-0.57-0.02-0.99-0.02-0.99c-0.2,0.03-0.4,0.07-0.59,0.11l-1.38,0.92l-1.54,1.55 C145.14,79.67,144.13,84.89,144.55,84.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M146.61,73.34c0.52-0.05,1.55-0.48,2.39,0.31c0.63,0.59,0.22,0.76,0.68,1.85c0.32,0.77-0.07,1.44-0.86,2.13 c-0.79,0.7-1.19,1.46-1.05,2.36c0.14,0.9-1.06,2.24-1.25,2.83c-0.18,0.59,0.05,1.12-0.48,1.72c-0.52,0.59-1.21,0.23-1.83,0.31 c-0.62,0.08-0.94,0.57-2.01,0.42c-1.07-0.15-1.18-0.84-1.39-1.39c-0.2-0.55-0.96-0.67-1.25-1.41s0.13-1.17,0-1.94 c-0.13-0.76-1.02-1.51-0.2-2.57c0.82-1.06,0.98-1.14,1.02-2.09c0.05-0.95,0.75-1.61,1.52-1.69c0.77-0.09,1.34-0.55,2.07-1.08 S145.76,73.43,146.61,73.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M146.59,81.56c0.23,0.68,0.86,1.07,1.41,0.89c0.55-0.19,0.8-0.89,0.57-1.57c-0.23-0.68-0.86-1.07-1.41-0.89 C146.61,80.18,146.35,80.89,146.59,81.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M147.8,80.48c-0.02-0.01-0.56-0.14-0.82,0.16c-0.07,0.08-0.1,0.18-0.12,0.29c0,0,0,0,0,0 c0,0.01,0,0.02,0,0.03c0,0,0,0,0,0c0,0,0,0,0,0c-0.02,0.21,0.05,0.49,0.2,0.83c0.02,0.04,0.06,0.06,0.1,0.05c0,0,0.01,0,0.01,0 c0.04-0.02,0.06-0.07,0.04-0.11c-0.12-0.27-0.18-0.5-0.19-0.67c0.49,0.03,0.8,0.53,0.8,0.54c0.02,0.03,0.06,0.05,0.09,0.04 c0.01,0,0.01,0,0.02-0.01c0.04-0.02,0.05-0.07,0.03-0.11c-0.01-0.03-0.35-0.59-0.93-0.63c0.01-0.05,0.03-0.09,0.06-0.13 c0.19-0.22,0.64-0.11,0.65-0.11c0.05,0.01,0.09-0.02,0.1-0.06C147.88,80.53,147.85,80.49,147.8,80.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M144.45,90.14c-0.03,1.8,2.75,5.59,4.23,7.74c0.73,1.06,2.29,2.68,4.18,3.77c1.93,1.11,4.2,1.68,6.28,0.55 c3.19-1.73,5-5.45,5.65-7.04c0.19-0.46,0.28-0.74,0.28-0.74c-1.14-0.25-1.88-1.27-1.88-1.27c-0.17,0.18-0.34,0.36-0.52,0.54 c-2.04,2.05-4.33,3.48-5.69,3.1c-1.55-0.44-4.39-5.02-6.2-7.5c-1.32-1.82-3.07-2.3-4.03-2.43c-0.44-0.06-0.72-0.04-0.72-0.04 s-0.48,0.47-0.92,1.21C144.77,88.61,144.46,89.35,144.45,90.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M142.14,87.04c0.06,0.06,0.12,0.13,0.19,0.2c0.14,0.14,0.31,0.28,0.52,0.4v0c0.42,0.25,1,0.45,1.81,0.44 c0.16,0,0.31-0.02,0.46-0.05c0.77-0.16,1.27-0.67,1.49-0.96c0.1-0.12,0.14-0.21,0.14-0.21c-0.44-0.06-0.72-0.04-0.72-0.04 s-0.85,0.58-1.64,0.58c-1-0.01-1.53-0.45-1.53-0.45S142.6,86.97,142.14,87.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M162.67,93.7c0.52,1.12,2.11,1.47,2.11,1.47h0c0.19-0.46,0.28-0.74,0.28-0.74c-1.14-0.25-1.87-1.29-1.87-1.29 C163.02,93.32,162.84,93.52,162.67,93.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M142.86,134.43c0.54,0,0.98-0.44,0.98-0.98v-18.01c0-0.54-0.44-0.98-0.98-0.98c-0.54,0-0.98,0.44-0.98,0.98 v18.01C141.88,133.99,142.31,134.43,142.86,134.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M133.36,138.39c1.81-0.05,0.04-3.11,3.4-3.4c0,0,12.47,0,12.47,0c1.34,0,2.42,1.09,2.42,2.42 c0,1.28,1.96,1.28,1.96,0c0-2.42-1.97-4.38-4.38-4.38h-12.47C133.68,132.64,130.72,137.88,133.36,138.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M140.97,115.79h3.77c1.19-0.03,1.49-1.1,1.39-2.1h-6.54C139.48,114.69,139.78,115.76,140.97,115.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M140.54,135.45h4.63c1.08-0.02,0.98-1.18,0.96-1.95c0-0.53-0.43-0.96-0.96-0.96h-4.63 c-0.53,0-0.96,0.43-0.96,0.96C139.56,134.27,139.46,135.43,140.54,135.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M150.78,137.4c0.04,2.43,3.66,2.43,3.7,0C154.44,134.97,150.82,134.97,150.78,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M131.51,137.4c0.04,2.43,3.66,2.43,3.7,0C135.17,134.97,131.55,134.97,131.51,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M126.86,84.85c0,0,5.13,0,7.86,0c1.08,0,2.12,0.39,2.9,1.09c1.35,1.22,2.73,2.44,3.53,3.12 c6.17,5.29-3.6,22.77,8.69,22.87c1.87,0.02,3.44,0.83,4.78,1.92c0.84,0.69,1.67,2.54,0.03,2.55c-0.52,0.01-1.17-0.72-1.51-1 c-1.08-1-2.51-1.55-4.03-1.55h-9.58c-10.81-0.18-7.86-13.36-7.8-19.71c0.03-2.99-4.04-5.7-5.86-7.65 C125.04,85.76,125.86,84.85,126.86,84.85z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorials);
export default __webpack_public_path__ + "static/media/tutorials.886c9da4e4d205453d86772f4c47c16a.svg";
export { ForwardRef as ReactComponent };